import React from 'react';
import {NavLink} from 'react-router-dom';
import clsx from 'clsx';
import {User} from '@icons/User';
import {Avatar} from '../Avatar';
import {avatarSizes} from '../Avatar/types';
import {HasAccess} from '../HasAccess';
import styles from './Navigation.module.scss';
import {mobileScreens} from './config';

export const NavigationMobile = () => {
    return (
        <div className={styles.navigationMobile}>
            {mobileScreens.map(({path, label, Icon}, index) => {
                if (path === '/profile') {
                    return (
                        <HasAccess
                            key={index}
                            def={
                                <NavLink
                                    to="/login"
                                    className={({isActive}) =>
                                        clsx(styles.navigationMobile__link, isActive && styles.navigationMobile__linkActive)
                                    }
                                >
                                    <User
                                        width={16}
                                        height={18}
                                        color="currentColor"
                                        style={{marginBottom: '6px'}}
                                    />
                                    Войти
                                </NavLink>
                            }
                        >
                            <NavLink
                                to={path}
                                className={({isActive}) =>
                                    clsx(styles.navigationMobile__link, isActive && styles.navigationMobile__linkActive)
                                }
                            >
                                <Avatar full_name={undefined} size={avatarSizes.sm} />
                                {label}
                            </NavLink>
                        </HasAccess>
                    );
                }

                return (
                    <NavLink
                        key={index}
                        to={path}
                        className={({isActive}) =>
                            clsx(styles.navigationMobile__link, isActive && styles.navigationMobile__linkActive)
                        }
                    >
                        <Icon
                            width={16}
                            height={18}
                            color="currentColor"
                            style={{marginBottom: '6px'}}
                        />
                        {label}
                    </NavLink>
                );
            })}
        </div>
    );
};
